import home_CN from './home_CN';
import localeDemo_CN from './localeDemo_CN';
import organizationAndUser_CN from './organizationAndUser_CN';
import terminalManagement_CN from './terminalManagement_CN';
import terminalDetect_CN from './terminalDetect_CN';
import ephemerisManagement_CN from './ephemerisManagement_CN';
import logs_CN from './logs_CN';
import rechargeSearch_CN from './rechargeSearch_CN';
import dateExtraFooter_CN from './dateExtraFooter_CN';
import groupTree_CN from './groupTree_CN';

const zh_CN = Object.assign(
  {},
  home_CN,
  localeDemo_CN,
  organizationAndUser_CN,
  terminalManagement_CN,
  terminalDetect_CN,
  ephemerisManagement_CN,
  logs_CN,
  rechargeSearch_CN,
  dateExtraFooter_CN,
  groupTree_CN,
);

export default zh_CN;